import React from 'react';
import PropTypes from 'prop-types';
import {Divider} from 'material-ui';
import styles from './Info.css';
import DOMPurify from "dompurify";

class Info extends React.Component {
    static propTypes = {
        title: PropTypes.string.isRequired,
        content: PropTypes.oneOfType([
            PropTypes.number,
            PropTypes.string,
            PropTypes.node
        ]),
        divider: PropTypes.bool,
        html: PropTypes.bool,
        children: PropTypes.node
    };

    static defaultProps = {
        divider: true,
        html: false
    };

    render() {
        const { children, content, html, title, divider } = this.props;
        let text;

        if (children === undefined && content !== undefined && content !== null) {
            if (html) {
                text = (
                    <div
                        style={styles.text}
                        dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(content)}}>
                    </div>
                );
            } else {
                text = <p style={styles.text}>{content}</p>;
            }
        } else {
            text = <p style={styles.emptytext}>no content</p>
        }

        return (
            <div>
                <p style={styles.label}>{title}</p>
                {children || text}
                {divider && <Divider/>}
            </div>
        );
    }
}

export default Info;



// WEBPACK FOOTER //
// src/components/common/Info/Info.js